"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationButton = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var NavigationButton = function (props) {
    var newProps = __assign({}, props);
    newProps.className = (0, classnames_1.default)('arrows', newProps.classes, newProps.className);
    delete newProps.currentSlide;
    delete newProps.slideCount;
    delete newProps.classes;
    delete newProps.ariaLabel;
    return react_1.default.createElement(Button, __assign({}, newProps, { "aria-label": props.ariaLabel, type: "button" }));
};
exports.NavigationButton = NavigationButton;
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0 none;\n  border-radius: 4px;\n  height: 28px;\n  top: -40px;\n  width: 28px;\n  z-index: 1;\n"], ["\n  border: 0 none;\n  border-radius: 4px;\n  height: 28px;\n  top: -40px;\n  width: 28px;\n  z-index: 1;\n"])));
exports.default = exports.NavigationButton;
var templateObject_1;
